import React from "react";
import { Link } from "react-router-dom";
import AdminRemoteAllPlayersTable from "./AdminRemoteAllPlayersTable";

export default function AdminRemoteAllPlayers() {
  return (
    <>
      <h1>
        <Link to={"/admin"}>Admin</Link> - All Players
      </h1>
      <AdminRemoteAllPlayersTable />
    </>
  );
}
